import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=cdef8e9c&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=cdef8e9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdef8e9c",
  null
  
)

export default component.exports